export default __webpack_public_path__ + "static/media/Inventory-icon.2094078c.svg";